import { render, staticRenderFns } from "./LatestArticles.vue?vue&type=template&id=2fd90f7e"
import script from "./LatestArticles.vue?vue&type=script&lang=js"
export * from "./LatestArticles.vue?vue&type=script&lang=js"
import style0 from "./LatestArticles.vue?vue&type=style&index=0&id=2fd90f7e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports